import StepWrapper from "./StepWrapper";
import { Form } from "react-bootstrap";

const ExpenseCategoryStep = ({ data, onSubmit, totalSteps }) => (
  <StepWrapper
    step={data.step}
    total={totalSteps}
    disableNext={!data.transactionItem}
    onPrev={() => onSubmit({ step: data.step - 1 })}
    onNext={() => onSubmit({ step: data.step + 1 })}
  >
    <Form.Group>
      <Form.Label>Expense Item</Form.Label>
      <Form.Control
        type="text"
        placeholder="Enter the type of expense"
        value={data.transactionItem || ""}
        onChange={(e) => onSubmit({ transactionItem: e.target.value })}
        required
        autoFocus
      />
    </Form.Group>
  </StepWrapper>
);

export default ExpenseCategoryStep;
